module.exports = __webpack_public_path__ + "img/collection-engagementRings070Carat@2x.850c34a.webp";